<template>
  <div>
    <template v-for="(item, index) in cities">
      <lazy-component
        :key="index"
        :class="['video-wrap', { 'video-wrap-show': cityOnPlaying === item.id }]"
        @show="afterLoaded"
      >
        <audio :id="item.id" loop :src="require(`../../assets/personality/voice/${item.id}.mp3`)"></audio>
        <img v-if="vm.isMobile" :src="require(`../../assets/zh/personality/personality-relax-${item.id}.jpg`)" />
        <video
          v-else
          :id="item.id"
          muted
          :autoplay="item.id === 'beijing'"
          :poster="require(`../../assets/personality/personality-relax-${item.id}.jpeg`)"
          alt="ColorOS 11 OPPO Relax"
        >
          <source :src="require(`../../assets/personality/personality-relax-${item.id}.webm`)" type="video/webm" />

          <source :src="require(`../../assets/personality/personality-relax-${item.id}.mp4`)" type="video/mp4" />
        </video>
      </lazy-component>
    </template>
  </div>
</template>

<script>
export default {
  inject: ['vm'],
  props: {
    cityOnPlaying: {
      type: String,
      default: 'beijing'
    }
  },
  data() {
    return {
      cities: [
        { country: '中国', city: '北京', color: '#f2bc99', id: 'beijing' },
        { country: '中国', city: '深圳', color: '#3DFFF3', id: 'shenzhen' },
        { country: '冰岛', city: '雷克雅未克', color: '#3e3e74', id: 'bingdao' },
        { country: '日本', city: '东京', color: '#482316', id: 'riben' },
        { country: '泰国', city: '曼谷', color: '#331409', id: 'taiguo' }
      ]
    };
  },
  watch: {
    cityOnPlaying(newVal, oldVal) {
      //播放音乐
      if (newVal === oldVal) {
        this.handlePlaying();
      } else {
        this.playVoice(true);
        oldVal && this.pauseVoice(oldVal);
      }
    }
  },
  methods: {
    afterLoaded() {
      setTimeout(() => {
        this.cities.forEach(city => {
          this[city.id] = Array.from(this.$el.querySelectorAll('#' + city.id));
        });
      }, 300);
    },
    playVoice(playWithStart) {
      this[this.cityOnPlaying].forEach((dom, index) => {
        if (playWithStart) {
          dom.currentTime = 0;
          dom.play();
          return;
        }
        if (index === 1 && dom.ended) return;
        dom.play();
      });
    },
    pauseVoice(id) {
      this[id].forEach(dom => {
        dom.pause();
      });
    },
    handlePlaying() {
      this[this.cityOnPlaying][0].paused ? this.playVoice() : this.pauseVoice(this.cityOnPlaying);
    },
    setVoiceVolume(val) {
      // 确保音量在【0，1】之间
      let v = Math.max(0, Math.min(1, val));
      //第2个元素为音频dom
      this[this.cityOnPlaying][0].volume = v;
    }
  }
};
</script>

<style lang="scss" scoped>
.video-wrap {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.5s cubic-bezier(0.1, 0, 0.1, 1);

  video {
    width: 308px;
    height: 682px;
    border-radius: 27px;
  }
}
.video-wrap-show {
  opacity: 1;
  transition: opacity 0.5s cubic-bezier(0.1, 0, 0.1, 1);
}
@media only screen and (max-width: 1440px) {
  .video-wrap video {
    width: 246.6px;
    height: 545.4px;
  }
}
@media only screen and (max-width: 734px) {
  .video-wrap {
    width: 206px;
    height: 453px;
    top: 10px;
    left: 5px;
    img,
    video {
      width: 206px;
      height: 453px;
      transform: none;
      border-radius: 0;
    }
  }
}
</style>
